export const getMessageClassificationPayload = (message, messageClassification) => {
  const {
    conversationState: {
      editorState: {
        previewActions
      }
    }
  } = message;
  const payload = {};
  previewActions.map(action => {
    //if it doesn't have a value, it must have been optional
    if (messageClassification[action.payloadKey].value) {
      payload[action.payloadKey] = messageClassification[action.payloadKey].value;
      if (action.payloadReasonDescriptionKey) {
        payload[action.payloadReasonDescriptionKey] = messageClassification[action.payloadKey].label;
      }
    }
  });
  if (payload.tags) {
    payload.tags = payload.tags.concat(message.readOnlyTags);
    if (messageClassification.tags.pristine && payload.tags.length === 0) {
      Reflect.deleteProperty(payload, "tags");
    }
  }
  if (!messageClassification.msgClassification.pristine && messageClassification.msgClassification.classificationCode) {
    payload.msgClassification = messageClassification.msgClassification;
    Reflect.deleteProperty(payload.msgClassification, "pristine");
    Reflect.deleteProperty(payload.msgClassification, "isStepComplete");
    Reflect.deleteProperty(payload.msgClassification, "doLiveUpdate");
  }
  return payload;
};